export default [
    {
        path: '/admin/academic/subject-profiles',
        name: 'subject-profile',
        meta: { requiresAuth: true },
        component: () => import('@/pages/academic/subject-profile/index.vue')
    }
]
